import { isAndroid } from 'react-device-detect';
import { createActions, handleActions } from 'redux-actions';

const defaultState = {
  error: null, data: {
    productSlideActive: true,
    isFullScreen: true,
    viewAmount: 0,
    isCoinActive: true,
    isCoupon: true,
    isPage: undefined,
    isMute: true,
    isCheckOut: false,
    isInitPage: false,
    isMobile: false,
    screenWidth: 0
  }, isLoading: false
};

export const { requestInit, requestSetSystemsInfo, requestSystemsInfoStart, requestSystemsInfoSuccess, requestSystemsInfoFail } = createActions({
  REQUEST_INIT: data => ({ data }),
  REQUEST_SET_SYSTEMS_INFO: data => ({ data }),
  REQUEST_SYSTEMS_INFO_START: data => ({ data }),
  REQUEST_SYSTEMS_INFO_SUCCESS: data => ({ data }),
  REQUEST_SYSTEMS_INFO_FAIL: error => ({ error }),
});

export const reducer = handleActions(
  {
    [requestInit]: (state) => ({ ...state, ...defaultState }),
    [requestSetSystemsInfo]: (state, { payload: { data } }) => ({ error: null, isLoading: false, data, }),
    [requestSystemsInfoStart]: (state) => ({ ...state, error: null, isLoading: true }),
    [requestSystemsInfoSuccess]: (state, { payload: { data } }) => ({ error: null, isLoading: false, data: data, }),
    [requestSystemsInfoFail]: (state, { payload: { error } }) => ({ error, isLoading: false, data: null }),
  },
  defaultState,
);
